import SuperRepository from '../superRepository'

export default new (class TrafficSourcesRepository extends SuperRepository {
  baseUri() {
    return 'traffic_source'
  }
})()
